import { render } from "./ReservationForm.vue?vue&type=template&id=226d58e3"
import script from "./ReservationForm.vue?vue&type=script&lang=js"
export * from "./ReservationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__